import { Pipe, PipeTransform } from '@angular/core';
import { AggregatedStatus } from '@vi-iot/client/models';
import { PillType } from '../../../../shared/components/pill/pill.model';

@Pipe({
  name: 'aggregatedStatusPill',
  standalone: true,
})
export class AggregatedStatusPillPipe implements PipeTransform {
  transform(aggregatedStatus: AggregatedStatus): { pillType: PillType; label: string } {
    switch (aggregatedStatus) {
      case AggregatedStatus.Maintenance:
        return {
          pillType: PillType.primary,
          label: '+INSTALLATIONS.INSTALLATION.STATUS.MAINTENANCE',
        };
      case AggregatedStatus.Offline:
        return {
          pillType: PillType.secondary,
          label: '+INSTALLATIONS.INSTALLATION.STATUS.OFFLINE',
        };
      case AggregatedStatus.WorksProperly:
        return {
          pillType: PillType.success,
          label: '+INSTALLATIONS.INSTALLATION.STATUS.WORKING',
        };
      case AggregatedStatus.RemoteDiagnosticSession:
        return {
          pillType: PillType.info,
          label: '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.REMOTE_DIAGNOSTIC',
        };
    }
  }
}
